import React from "react";
import _ from "lodash";
import history from "./history";
import { storage, STORAGE_KEYS } from "../utils/storage";

export default (WrappedComponent) => {

	class WithoutAuth extends React.Component {

		componentDidMount() {
			const accessToken = storage.get(STORAGE_KEYS.accessToken);
			if (!_.isEmpty(accessToken)) {
				history.push("/lottery5")
			}
		}

		render() {
			const accessToken = storage.get(STORAGE_KEYS.accessToken);
			if (!_.isEmpty(accessToken)) {
				return null
			}

			return (<WrappedComponent {...this.props} />);
		}
	}

	return WithoutAuth
}
